import { ABaseModel } from '../abstracts/ABaseModel.js';
import { IEmailSubscription, IMailingList } from '../interfaces/Email.js';

/**
 * EmailSubscription
 */
class EmailSubscription extends ABaseModel implements IEmailSubscription {
  id: number;
  status: number;
  type: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * MailingList
 */
class MailingList extends ABaseModel implements IMailingList {
  id: number;
  status: number;
  type: string;
  emailAddressId: number;
  emailAddress: string;
  visitorId: number;
  visitorCohort: string;
  visitorLanguage: string;
  visitorLocale: string;
  visitorRole: string;
  visitorEmail: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { MailingList, EmailSubscription };
